export default __webpack_public_path__ + "static/PAPA_FRITAS-df69ff7bdc0692c595c1950000992737.jpg";